import { useQuery } from '@tanstack/react-query';

// helper
import { BaseError } from '../../helpers/BaseError';

// models
import { FormulaStatusCountModel } from '../../models/formula-sequence.model';

// services
import API from '../../services/api';

import formulaMessageKeys from './__queryKeys';

const getFormulaSequencesStatusCount = async () => {
    const { data } = await API.fetchFormulaSequencesStatusCount();
    return data as FormulaStatusCountModel;
};

export default function useFormulaSequencesStatusCountQuery() {
    return useQuery<FormulaStatusCountModel, BaseError>({
        queryKey: formulaMessageKeys.sequencesCatalogCount(),
        queryFn: getFormulaSequencesStatusCount,
        staleTime: 60000,
    });
}
